import { component } from 'picoapp'
import { zelektor, loopify, smoothScroll } from '@/lib/utility-functions.js'
import { prepareSlides, initSliderWrapper, initDots, updateDots } from '@/lib/keen-slider.js'
import KeenSlider from 'keen-slider'
import 'fslightbox'
import smoothscroll from 'smoothscroll-polyfill'

export default component((node, ctx) => {
    /*******************************************************************************************************************************************/
    /* Data + Elements
    /*******************************************************************************************************************************************/
    const {
        thumbnailsPrev,
        thumbnailsNext,
        thumbnails,
        thumb: singleThumbs,
        imageSliderWrapper,
        imageSlider: imageSliderElement,
        dotsWrapper
    } = zelektor(node)

    smoothscroll.polyfill()


    /*******************************************************************************************************************************************/
    /* Image Slider
    /*******************************************************************************************************************************************/
    // Slider
    prepareSlides(imageSliderElement)

    const imageSlider = new KeenSlider(imageSliderElement, {
        duration: 0,
        created: slider => {
            initSliderWrapper(imageSliderWrapper)
            initDots(slider, imageSliderElement, dotsWrapper)
            updateDots(slider, dotsWrapper)
        },
        afterChange: slider => {
            const sliderData = slider.details()
            updateSlider(sliderData)
            updateThumbnailBtns(sliderData)
            updateActiveThumb(sliderData)
            updateDots(slider, dotsWrapper)
        }
    })


    // Thumbnails
    Array.from([thumbnailsPrev, thumbnailsNext]).forEach(btn => {
        btn.addEventListener('click', e => {
            const sliderData = imageSlider.details()
            const thisBtn = e.currentTarget
            
            thisBtn === thumbnailsPrev ? sliderData.direction = -1 : sliderData.direction = 1

            imageSlider.moveToSlide(sliderData.relativeSlide + sliderData.direction)
            scrollThumbnails(sliderData)
        })
    })
    if (Array.isArray(singleThumbs)) {
        singleThumbs.forEach((thumb, index) => {
            thumb.addEventListener('click', () => {
                imageSlider.moveToSlide(index)
            })
        })
    }
    

    // Functions
    function updateSlider(sliderData) {
        const { slide: slides = [] } = zelektor(imageSliderElement)
        
        loopify(slides).forEach((slide, index) => {
            if (sliderData.relativeSlide === index) {
                slide.style.opacity = '1'
                slide.style.pointerEvents = 'all'
            } else {
                slide.style.opacity = '0'
                slide.style.pointerEvents = 'none'
            }
        })
    }

    function updateThumbnailBtns(sliderData) {
        sliderData.relativeSlide === 0
        ? thumbnailsPrev.classList.remove('is-active')
        : thumbnailsPrev.classList.add('is-active')
        
        sliderData.relativeSlide === sliderData.size - 1
        ? thumbnailsNext.classList.remove('is-active')
        : thumbnailsNext.classList.add('is-active')
    }

    function updateActiveThumb(sliderData) {
        const index = sliderData.relativeSlide
        if (Array.isArray(singleThumbs)) {
            singleThumbs.forEach((thumb, i) => {
                i === index
                ? thumb.classList.add('is-active')
                : thumb.classList.remove('is-active')
            })
        }
    }

    function scrollThumbnails(sliderData) {
        const thumbHeight = singleThumbs[0].getBoundingClientRect().height
        const spacing = parseInt(getComputedStyle(singleThumbs[0]).marginBottom)
        const scrollAmount = thumbHeight + spacing
        
        const updatedIndex = sliderData.relativeSlide + sliderData.direction
        let scrollTarget = thumbnails.scrollTop + scrollAmount * sliderData.direction

        if (updatedIndex < sliderData.size || updatedIndex >= 0) performScroll()

        function performScroll() {
            thumbnails.scroll({
                top: scrollTarget,
                left: 0,
                behavior: 'smooth'
            })

            // smoothScroll(scrollTarget, {
            //     element: thumbnails
            // })
        }
    }
})